<template>
  <div class="target-top__layout">
    <v-layout row wrap class="pa-3">
      <v-flex md4 lg3 xs12 class="elevation-1" style="text-align:center;padding:0 5px 5px 20px;margin-bottom: 10px;">
        <img class="pa-1" height="320"
          :src="apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + $route.params.compound" />
        <v-layout row wrap>
          <v-flex md12 lg12 xs12 style="width:100%;">
            <div class="pr-3">
              <div class="carousel-table-value">Synonyms</div>
              <div class="carousel-table-title">
                <span v-if="!compound2.compound_names.length"> - </span>
                <span v-if="compound2.compound_names.length" v-for="(name, i) in compound2.compound_names" :key="i">
                  {{name}}
                  <span v-if="i < compound2.compound_names.length - 1">, </span>
                </span>
              </div>
            </div>
            <div class="pr-3">
              <div class="carousel-table-value">Molecular Formula</div>
              <div class="carousel-table-title">{{compound2.MOLECULAR_FORMULA}}</div>
            </div>
            <div class="pr-3">
              <div class="carousel-table-value">InChl</div>
            </div>
            <div class="pr-3">
              <div class="carousel-table-title" style="overflow:auto;">{{compound2.INCHI}}</div>
            </div>
            <div class="pr-3">
              <div class="carousel-table-value">Cross References</div>
            </div>
            <div class="pr-3">
              <div style="overflow:auto;">
                <table style="width:100%;border-spacing:0;border: 1px solid #4DB6AC;">
                  <tr v-for="(link, key) in compound2.easy_xrefs" :key="key">
                    <td class="carousel-table-value-2">{{link[0]}}</td>
                    <td class="carousel-table-title-3" v-if="!link[1].length">{{link[2]}}</td>
                    <td class="carousel-table-title-3" style="padding:2px 0 1px 0"><a v-if="link[1].length" :href="link[1]" target="_blank">{{link[2]}}</a></td>
                  </tr>
                </table>
              </div>
            </div>
            <div style="width:100%;" class="pr-3">
              <table style="width:100%;border-spacing:0;border: 1px solid #4DB6AC;">
                <tbody>
                  <tr><td class="carousel-table-value">Commercially Available</td></tr>
                  <tr><td class="carousel-table-title">{{compound2.commercially_available}}</td></tr>
              </tbody>
              </table>
            </div>
          </v-flex>
          <v-flex md12 lg12 xs12>
            <div class="pr-3" style="width:100%;">
              <table style="width:100%;border-spacing:0;border: 1px solid #4DB6AC;">
                <tbody>
                  <tr class="carousel-table-value"><td class="carousel-table-value">Properties</td></tr>
                </tbody>
              </table>
            </div>
            <div class="pr-3" style="width:100%;">
              <table style="width:100%;border-spacing:0;border: 1px solid #4DB6AC;">
                <tbody>
                <tr>
                  <td class="carousel-table-value-2">Molecular Weight</td>
                  <td class="carousel-table-title-3" :style="{color: compound2.MOLECULAR_WEIGHT < compound2.property_thresholds.MOLECULAR_WEIGHT ? 'green': 'red'}">{{parseFloat(compound2.MOLECULAR_WEIGHT).toFixed(1)}}</td>
                </tr>
                <tr>
                  <td class="carousel-table-value-2">ALOGP</td>
                  <td class="carousel-table-title-3" :style="{color: compound2.ALOGP < compound2.property_thresholds.ALOGP ? 'green': 'red'}">{{parseFloat(compound2.ALOGP).toFixed(1)}}</td>
                </tr>
                <tr>
                  <td class="carousel-table-value-2">HBOND DONORS</td>
                  <td class="carousel-table-title-3" :style="{color: compound2.HBOND_DONORS < compound2.property_thresholds.HBOND_DONORS ? 'green': 'red'}">{{compound2.HBOND_DONORS}}</td>
                </tr>
                <tr>
                  <td class="carousel-table-value-2">HBOND ACCEPTORS</td>
                  <td class="carousel-table-title-3" :style="{color: compound2.HBOND_ACCEPTORS < compound2.property_thresholds.HBOND_ACCEPTORS ? 'green': 'red'}">{{compound2.HBOND_ACCEPTORS}}</td>
                </tr>
                <tr>
                  <td class="carousel-table-value-2">ATOMS</td>
                  <td class="carousel-table-title-3" :style="{color: compound2.ATOMS < compound2.property_thresholds.ATOMS ? 'green': 'red'}">{{compound2.ATOMS}}</td>
                </tr>
                <tr>
                  <td class="carousel-table-value-2">CONTAINS TOXICOPHORE</td>
                  <td class="carousel-table-title-3" :style="{color: compound2.CONTAINS_TOXICOPHORE ? 'RED': 'GREEN'}">{{compound2.CONTAINS_TOXICOPHORE ? 'YES' : 'NO'}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md8 lg9 xs12>
        <v-layout row wrap>
          <v-flex md12 lg6 xs12>
            <div class="target-top__layout__summary-subtitle">
              DATA
            </div>
            <v-layout row wrap class="pa-1">
              <v-flex xs12>
                <div style="width:100%">
                  <table style="width:100%;border-spacing:0;" id="data-table">
                    <tr>
                      <td class="carousel-table-title-1">Global Score/Rank</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.global_rank_text}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Global Score/Rank (default weights)</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.global_default_weight_rank_text}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Meets minimum quality criteria</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.suitable_probe}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Number of SAR compounds</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.sar_raw}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Number of inactive analogs</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.inactive_analogs_raw}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">PAINS Alerts</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.pains_text}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Number of secondary targets tested</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.no_secondary_targets}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Number of secondary targets 10-fold selective</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.no_secondary_targets_selective}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Median Target Potency(nM)</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.median_target_potency}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Median Absolute Deviation</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.median_absolute_deviation}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">SIC</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.selectivity_information_content.toFixed(2)}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Number of cell lines tested</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.no_celllines}}</td>
                    </tr>
                    <tr>
                      <td class="carousel-table-title-1">Number of cell lines where the tool is active (< 10um)</td>
                      <td class="carousel-table-value-1">{{compound.data_compound.no_celllines_active}}</td>
                    </tr>
                  </tr>

                  </table>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md12 lg6 xs12>
            <div class="target-top__layout__summary-subtitle">
              FEATURES
              <v-icon id="features-tooltip" class="features-more">info</v-icon>
              <div id="icons-details" style="display: none;">
                <div style="text-align:left;font-weight:600;padding:0 0 2px 3px">When the icon is coloured it has the following meaning:</div>
                <table class="icons-table">
                  <tr v-for="(value, key) in features" :key="key">
                    <td><img :src="value.imageValid" height="15" width="15" style="background:#ffffff;"></td>
                    <td>{{value.textValidCompound}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="target-top__layout__summary-content-main">
              <prb-features :compound="compound.data_compound" :features="features"></prb-features>
            </div>
            <div class="target-top__layout__summary-content-main">
              <div id="spider" style="height:200px;width:100%"></div>
            </div>
          </v-flex>

          <v-flex xs12 lg12 md12 class="profile">
            <div class="target-top__layout__summary-subtitle">
              PROTEIN AFFINITY PROFILE <span v-tooltip:top="{ html: 'pActivity is the meadian of all pKi, pKd and pIC50 values for each target-compound pair' }"><v-icon style="color:#455A64;margin-bottom:5px;cursor:pointer;">info</v-icon></span>
            </div>
            <div id="bar-profile" style="width:100%;height:500px"></div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import 'tippy.js/dist/tippy.css'
import tippy from 'tippy.js'
import * as F from '../../../constants/Features';

var Highcharts = require('highcharts');
require('highcharts/modules/data')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/stock')(Highcharts);

import highchartsMore from 'highcharts/highcharts-more'

import PrbFeatures from './prb-features/PrbFeatures';

export default {
  props: ['compound', 'compound2'],
  components: {PrbFeatures},
  computed: mapGetters([
    'loading'
  ]),
  beforeMount() {
    this.features = F.FEATURES;
  },
  data() {
    return {
      apiUrl: process.env.API_URL
    }
  },
  mounted() {
    this.$store.dispatch("SET_LOADING");

    tippy('#features-tooltip', {
      html: '#icons-details',
      duration: 1000,
      arrow: true,
      trigger: 'mouseenter'
    })

    this.createSpider();

    let categories = [];
    let values = [];

    let uniprots = this.compound.data_uniprots.sort(function(a, b){
      let keyA = a.y,
          keyB = b.y;

      if(keyA < keyB) return 1;
      if(keyA > keyB) return -1;
      return 0;
    });

    uniprots.map(function(m, i){
      categories.push(m.name);
      values.push(m.y)
    });

    this.createBar(categories, values);

    this.$store.dispatch("UNSET_LOADING");
  },
  methods: {
    createSpider() {

      let that = this;

      that.spiderChart = Highcharts.chart('spider', {

        chart: {
          polar: true,
          type: 'line',
          renderTo: 'spider',
          style: {
            fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
          }
        },

        title: {
          text: '',
          x: -80
        },

        pane: {
          size: '80%'
        },

        xAxis: {
          categories: ['PAINS-free', 'Selectivity', 'Target Potency', 'Cell Potency', 'SAR', 'Inactive Analogs'],
          tickmarkPlacement: 'on',
          lineWidth: 0,
          padding: 0,
          labels: {
            style: {
              color: 'rgba(0,0,0,.7)'
            }
          }
        },

        yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 0,
          min: 0,
          tickPositioner: function(min, max) {
            return [min, max];
          }
        },

        tooltip: {
          pointFormat: "Value: {point.y:.2f}"
        },

        legend: {
          align: 'right',
          verticalAlign: 'top',
          y: 70,
          layout: 'vertical'
        },

        series: [{
          name: 'Values',
          showInLegend: false,
          color: '#4DB6AC',
          data: [that.compound.data_compound.pains, that.compound.data_compound.selectivity, that.compound.data_compound.target_potency, that.compound.data_compound.cell_potency, that.compound.data_compound.sar, that.compound.data_compound.is_inactive_analogs],
          pointPlacement: 'on'
        }]
      });
    },
    createBar(categories, values) {
      let that = this;

      that.barChart = Highcharts.chart('bar-profile', {
        chart: {
            type: 'column',
            renderTo: 'bar-profile',
            style: {
              fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
            }
        },
        title: {
            text: 'Protein Affinity Profile'
        },
        navigator: {
            enabled: true,
            xAxis: {
                labels: {
                    formatter: function() {
                        return null;
                    }
                }
            },
            series: {
          	type: 'areaspline',
          	color: '#4DB6AC',
          	fillOpacity: 0.1,
          	dataGrouping: {
          		smoothed: true
          	},
          	lineWidth: 0,
          	marker: {
          		enabled: false
          	}
          }
        },
        xAxis: {

          categories: categories,
          xAxis: {labels: {   formatter: function () {return this.value;}} }
        },
        yAxis: {
          title: {
              text: 'pActivity'
          },
          min: 0
        },
        plotOptions: {
          spline: {
              marker: {
                  enabled: true
              }
          }
        },
        series: [{
            name: 'pActivity',
            data: values,
            showInLegend: false,
            color: '#4DB6AC',
            pointPadding: 0.01,
            groupPadding: 0
          }]
      });
    }
  }
}
</script>

<style scoped>
  .target-top__layout{
    width: 100%;
  }
  .target-top__layout__summary-subtitle{
    width: 100%;
    font-size: 20px;
    padding: 10px;
    font-weight: 600;
    border-left: 5px solid #455A64;
    color: #455A64;
    background: rgba(0,0,0,.03);
  }
  .target-top__layout__summary-content-main {
    max-height: 130px;
    padding: 10px 0;
  }
  .features-more {
    font-size: 18px;
    padding: 0 0 5px 0;
    cursor: pointer;
    color: #2c3e50 !important;
  }

  .features-more:hover {
    color: #1e88e5 !important;
  }

  .carousel-table-value {
    background: #4DB6AC;
    color: white;
    padding: 10px;
  }
  .carousel-table-value-1 {
    color: #4DB6AC;
    text-align: center;
    font-weight: 600;
    padding: 1px 0 1px 10px;
  }

  .carousel-table-value-2 {
    text-align: center;
    font-weight: 600;
    padding: 1px 0 1px 10px;
    border-bottom: 1px solid #4DB6AC;
  }

  .carousel-table-title {
    border: 1px solid #4DB6AC;
    padding: 1px 5px 1px 5px;
  }

  .carousel-table-title-3 {
    border-bottom: 1px solid #4DB6AC;
    padding: 1px 5px 1px 5px;
  }

  .icons-table {
    width: 100%;
    max-width: 100%;
  }

  .icons-table td {
    padding: 0 8px !important;
    text-align: left;
  }
  .carousel-table-title-1 {
    padding: 3px !important;
  }
  .profile{
    margin-top: 20px;
  }

  @media screen and (max-width: 1000px) {
    .carousel-table-value{
      font-size: 18px !important;
    }
    .carousel-table-value-1{
      font-size: 18px !important;
    }
    .carousel-table-value-2{
      font-size: 18px !important;
    }
    .carousel-table-title{
      font-size: 18px !important;
    }
    .carousel-table-title-1{
      font-size: 18px !important;
    }
    .carousel-table-title-3 {
      padding: 0 !important;
      font-size: 17px !important;
    }

  }
  @media screen and (max-width: 1424px) {
    .profile{
      margin-top: 150px;
    }
  }

  #data-table tr:nth-child(odd) {background: #ffffff;}
  #data-table tr:nth-child(odd) {background: rgba(77, 182, 172, 0.15)}
</style>



// WEBPACK FOOTER //
// PrbCompoundTop.vue?12e04e85